export function libs(): string {
  return 'libs';
}
